import { Action, Module, Mutation,
  VuexModule } from 'vuex-module-decorators';
import { page } from '@/services/api';
import { IPageAboutTranslations, IAboutPage } from '@/types';

const SET_RENTERS_TRANSLATION = 'SET_RENTERS_TRANSLATION';

const rawError: boolean = true;

@Module({namespaced: true})
export default class AboutPage extends VuexModule implements IAboutPage {
  public translation: IPageAboutTranslations = {
    headerBgImg: {},
    faq: {},
    callBack: {},
  };

  public get translations(): {} {
    return this.translation;
  }

  public get headerBgImg(): {} {
    return this.translation.headerBgImg;
  }

  public get faq(): {} {
    return this.translation.faq;
  }

  public get callBack(): {} {
    return this.translation.callBack;
  }

  @Mutation
  public [SET_RENTERS_TRANSLATION](payload: IPageAboutTranslations): void {
    this.translation = payload;
  }

  @Action({commit: SET_RENTERS_TRANSLATION, rawError})
  public async fetchTranslation() {
    const data = await page('to_renters');
    return data ? data : this.translation;
  }

}
